import React from 'react';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { getCherrySoftwareIcon } from '../cherrySoftwareIcons';

const normalizeItem = (item) =>
  typeof item === 'string' ? { text: item, icon: 'verified' } : item;

const CheckList = ({ items, dense = false, inverted = false }) => {
  const theme = useTheme();

  return (
    <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
      {items.map((raw) => {
        const item = normalizeItem(raw);
        const Icon = getCherrySoftwareIcon(item.icon);

        return (
          <Box
            component="li"
            key={item.text}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              mb: dense ? 1.5 : 2.25,
            }}
          >
            <Box
              sx={{
                width: dense ? 30 : 36,
                height: dense ? 30 : 36,
                borderRadius: inverted ? '50%' : '12px',
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                bgcolor: inverted
                  ? alpha(theme.palette.common.white, 0.16)
                  : alpha(theme.palette.primary.main, 0.1),
                color: inverted ? theme.palette.common.white : theme.palette.primary.main,
                border: inverted ? 'none' : `1px solid ${alpha(theme.palette.primary.main, 0.14)}`,
                '& svg': { fontSize: dense ? 16 : 18 },
              }}
            >
              <Icon />
            </Box>
            <Typography
              variant={dense ? 'body2' : 'body1'}
              color={inverted ? 'common.white' : 'textPrimary'}
              sx={{ lineHeight: 1.5, opacity: inverted ? 0.95 : 1 }}
            >
              {item.text}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

CheckList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        icon: PropTypes.string,
      }),
    ]),
  ).isRequired,
  dense: PropTypes.bool,
  inverted: PropTypes.bool,
};

export default CheckList;
